import { getGTMEventData } from '@tracking/components/transformer';
import { EVENT_NAMES } from '@tracking/components/constants';

function formSubmitStatusFormatter({ stage, status, message }) {
  return getGTMEventData(
    EVENT_NAMES.FORM_SUBMIT_STATUS,
    message,
    {
      status,
      message: status ? 'success' : message,
      formId: stage,
      extraInfo: message,
    },
    stage,
  );
}

export default formSubmitStatusFormatter;
